import { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { dashboardActions } from '../../../../../../../store/slices/dashboardSlice/dashboardSlice';

export const useProjectTeamRow = () => {
    const dispatch = useDispatch();
    //@ts-ignore
    const { is_customer, can_show_financial_info } = useSelector((state) => state.dashboardReducer);
    const addMemberToTeam = useCallback(() => {
        dispatch(dashboardActions.onModalMode('teamProject'));
    }, []);

    return { addMemberToTeam, is_customer, can_show_financial_info };
};
